import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheUnCookieCutterPhilosophy() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="the-un-cookie-cutter-philosophy" className="bg-background py-24 lg:py-32 overflow-hidden" ref={ref}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          {}
          <div className={`w-full lg:w-3/5 flex flex-col items-start transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10"}`}>
            
            <h2 className="font-bold text-primary font-montserrat leading-tight mb-6 !text-6xl">Hello. <br />Welcome to SayKen!​</h2>
            <p className="text-base font-montserrat leading-[1.8] mb-8 max-w-2xl !text-[hsl(210,10%,23%)] !w-[576px] md:text-lg">SayKen is a boutique tourist agency that brings the history, culture, and beauty of Israel to life. We offer immersive tours that will take you into the heart and soul of this amazing country. Just Say Ken (Yes in Hebrew!), and join us on an unforgettable experience in Israel.</p>
            
            <Button asChild className="group bg-primary text-primary-foreground hover:bg-primary/90 px-8 py-6 text-base rounded-md shadow-lg transition-all duration-300">
              <Link to="#plan-your-trip">
                PLAN YOUR TRIP
                <ArrowRight className="ml-2 h-5 w-5 transition-colors duration-300 group-hover:text-[var(--color-accent)]" />
              </Link>
            </Button>
          </div>

          {}
          <div className={`w-full lg:w-2/5 relative mt-16 lg:mt-0 min-h-[500px] lg:min-h-[650px] transition-all duration-700 delay-200 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            {}
            <div className="relative z-10 w-[85%] ml-auto shadow-2xl transform hover:scale-[1.02] transition-transform duration-500">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553131/img/mediterranean_village_vertical.png" alt="Scenic Mediterranean village with white buildings" className="h-auto object-cover shadow-xl !w-[386.234px] !rounded-lg !border-5 border-solid !border-[hsl(210,16%,93%)]" />
            </div>

            {}
            <div className="absolute -bottom-10 -left-4 lg:-left-12 w-[55%] z-20 shadow-2xl transform hover:scale-105 transition-transform duration-500">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553131/img/laughing_person_natural.png" alt="Traveler laughing in a candid moment" className="w-full h-auto object-cover rounded-lg shadow-2xl border-4 border-background !border-[hsl(210,16%,93%)] border-solid" />
            </div>

            {}
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-accent/30 rounded-full blur-3xl -z-10" />
          </div>
        </div>
      </div>
    </section>;
}